// Version kontrolü için utility
const APP_VERSION = '1.0.17'; // Her güncellemede bu versiyonu artırın

// Cookie'leri koruyarak localStorage'ı temizle
const clearLocalStorageExceptVersion = () => {
  // Sadece app_version'ı koru, diğerlerini temizle (opsiyonel)
  const version = localStorage.getItem('app_version');
  // localStorage.clear(); // İsterseniz açın
  localStorage.setItem('app_version', version);
};

// Cookie kontrolü - belirli cookie'lerin var olup olmadığını kontrol et
const checkCookie = (name) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName] = cookie.trim().split('=');
    if (cookieName === name) return true;
  }
  return false;
};

export const checkForUpdates = () => {
  const storedVersion = localStorage.getItem('app_version');
  
  if (storedVersion && storedVersion !== APP_VERSION) {
    // Yeni versiyon var, cache'i temizle ve yenile
    console.log(`🔄 Yeni versiyon tespit edildi: ${storedVersion} -> ${APP_VERSION}`);
    
    // Cookie'leri kontrol et ve koru
    const hasAuthToken = checkCookie('jodiactoken');
    console.log(`🍪 Cookie koruması: jodiactoken ${hasAuthToken ? 'mevcut' : 'yok'}`);
    
    // Service Worker'ı temizle
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      });
      console.log('✅ Service Worker temizlendi');
    }
    
    // Cache'i temizle (cookie'lere dokunmaz)
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
      console.log('✅ Browser cache temizlendi');
    }
    
    // LocalStorage'ı temizle (opsiyonel - gerekirse)
    // clearLocalStorageExceptVersion();
    
    // Yeni versiyonu kaydet
    localStorage.setItem('app_version', APP_VERSION);
    console.log(`✅ Version güncellendi: ${APP_VERSION}`);
    console.log(`🍪 Cookie'ler korundu (jodiactoken güvende)`);
    
    // Sayfayı yenile - cookie'ler otomatik korunur
    window.location.reload(true);
  } else if (!storedVersion) {
    // İlk yükleme
    localStorage.setItem('app_version', APP_VERSION);
    console.log(`📦 İlk yükleme: Version ${APP_VERSION} kaydedildi`);
  } else {
    console.log(`✅ Güncel versiyon: ${APP_VERSION}`);
  }
};

export const getCurrentVersion = () => APP_VERSION;

